import Vue from 'vue';
import Router from 'vue-router';

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue')
    },
    {
      path: '/check-notice-order/:id',
      name: '/check-notice-order',
      component: () => import('./views/order/check/CheckNoticeOrder.vue')
    },
    {
      path: '/',
      name: 'home',
      redirect: '/goods',
      component: () => import('./views/Home.vue'),
      children: [
        // { path: '/index', component: () => import('./views/Index.vue') },
        {
          path: '/index',
          redirect: '/goods',
          component: () => import('./views/goods/Goods.vue')
        },
        {
          path: '/notice-order-dahuo',
          component: () => import('./views/order/NoticeOrderDahuo.vue')
        },
        {
          path: '/notice-order-mayang',
          component: () => import('./views/order/NoticeOrderMayang.vue')
        },
        {
          path: '/new-notice-order-dahuo',
          component: () => import('./views/order/new/NewNoticeOrderDahuo.vue')
        },
        {
          path: '/modify-notice-order-dahuo/:id',
          component: () => import('./views/order/modify/ModifyNoticeOrderDahuo.vue')
        },
        {
          path: '/new-notice-order-mayang',
          component: () => import('./views/order/new/NewNoticeOrderMayang.vue')
        },
        {
          path: '/modify-notice-order-mayang/:id',
          component: () => import('./views/order/modify/ModifyNoticeOrderMayang.vue')
        },
        {
          path: '/change-password',
          name: '/change-password',
          component: () => import('./views/center/ChangePassword.vue')
        },
        {
          path: '/goods',
          component: () => import('./views/goods/Goods.vue')
        },
        {
          path: '/reconciliation-checklist',
          component: () => import('./views/order/ReconciliationChecklist.vue')
        },
        {
          path: '/detail-reconciliation-checklist/:id',
          component: () => import('./views/order/check/DetailReconciliationChecklist.vue')
        },
        {
          path: '/detail-unbilled-reconciliation-checklist/:id',
          component: () => import('./views/order/check/DetailUnbilledReconciliationChecklist.vue')
        },
        {
          path: '/order-stock',
          component: () => import('./views/order/OrderStock.vue')
        },
        {
          path: '/sale-order',
          component: () => import('./views/order/SaleOrder.vue')
        },
        {
          path: '/detail-sale-order/:id',
          component: () => import('./views/order/check/DetailSaleOrder.vue')
        }
        // {
        //   path: '/product-query',
        //   name: '/product-query',
        //   component: () => import('./views/query/ProductQuery.vue')
        // }
      ]
    }
  ]
});
